
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cafes-restaurants",
      function () {
        return require("private-next-pages/cafes-restaurants/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cafes-restaurants"])
      });
    }
  